import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Folgebrev from "./Folgebrev";

import { getFolgebrevWithParams as getFolgebrevWithParamsAction } from "../../../actions/folgebrevActions";
import {
    getMiljogebyr as getMiljogebyrAction,
    getMiljogebyrerHistorikk as getMiljogebyrerHistorikkAction,
    putMiljogebyrer as putMiljogebyrerAction,
} from "../../../actions/miljogebyrerActions";

export default function FolgebrevContainer({ miljogebyrId }) {
  const dispatch = useDispatch();
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const folgebrev = useSelector((state) => state.folgebrev);

  const getFolgebrev = useCallback(
    (params) => dispatch(getFolgebrevWithParamsAction(params)),
    [dispatch]
  );
  const getMiljogebyr = useCallback(
    (id) => dispatch(getMiljogebyrAction(id)),
    [dispatch]
  );
  const putMiljogebyrer = useCallback(
    (id, params) => dispatch(putMiljogebyrerAction(id, params)),
    [dispatch]
  );
  const getMiljogebyrerHistorikk = useCallback(
    (id) => dispatch(getMiljogebyrerHistorikkAction(id)),
    [dispatch]
  );

  return (
    <Folgebrev
      miljogebyrId={miljogebyrId}
      miljogebyr={miljogebyr}
      folgebrev={folgebrev}
      getFolgebrev={getFolgebrev}
      getMiljogebyr={getMiljogebyr}
      putMiljogebyrer={putMiljogebyrer}
      getMiljogebyrerHistorikk={getMiljogebyrerHistorikk}
    />
  );
}
